// Before/after view: changed top-level keys first (old → new), then the raw JSON on demand.
const show = (v) => (v === undefined ? "—" : typeof v === "object" && v !== null ? JSON.stringify(v) : String(v));
const isObj = (v) => v && typeof v === "object" && !Array.isArray(v);

export default function JsonDiff({ before, after, testId = "json-diff" }) {
  const keys = isObj(before) || isObj(after) ? [...new Set([...Object.keys(before || {}), ...Object.keys(after || {})])] : [];
  const changed = keys.filter((k) => JSON.stringify(before?.[k]) !== JSON.stringify(after?.[k]));
  return (
    <div className="space-y-3" data-testid={testId}>
      {changed.length > 0 ? (
        <table className="w-full table-fixed text-left text-xs" data-testid={`${testId}-changes`}>
          <thead><tr className="cw-muted"><th className="w-1/5 pb-1 font-medium">Field</th><th className="pb-1 font-medium">Before</th><th className="pb-1 font-medium">After</th></tr></thead>
          <tbody>{changed.map((k) => (
            <tr key={k} className="align-top">
              <td className="py-1 pr-3 font-mono">{k}</td>
              <td className="cw-tone-error break-all rounded-l px-2 py-1 font-mono">{show(before?.[k])}</td>
              <td className="cw-tone-success break-all rounded-r px-2 py-1 font-mono">{show(after?.[k])}</td>
            </tr>
          ))}</tbody>
        </table>
      ) : <p className="cw-muted text-xs">{before == null && after == null ? "No before/after recorded." : "No field-level differences."}</p>}
      <details className="text-xs"><summary className="cw-soft cursor-pointer">Raw before / after</summary>
        <div className="mt-2 grid gap-3 md:grid-cols-2">
          {[["Before", before], ["After", after]].map(([l, v]) => (
            <pre key={l} className="max-h-64 overflow-auto rounded-xl bg-[var(--cw-surface-tertiary)] p-3 leading-5"><span className="cw-muted">{l}</span>{"\n"}{v == null ? "—" : JSON.stringify(v, null, 2)}</pre>
          ))}
        </div>
      </details>
    </div>
  );
}
